import React, { useEffect } from 'react';

import { useStore, useTranslation } from '../../../../hooks';
import { T } from '../../../../constants';

import PromoLoader from '../../../../assets/media/promo/loader.png';
import PromoGift from '../../../../assets/media/promo/gift.png';

interface PromoModalProps {
  promoCode: string;
  onClose: () => void;
  claimLoading: boolean;
  claimSucceeded: boolean;
  onClaimClick: () => void;
  claimErrorMessage: string;
  claimSuccessMessage: string;
  onPromoCodeChange: (value: string) => void;
}

export const PromoModal: React.FC<PromoModalProps> = ({
  onClose,
  promoCode,
  claimLoading,
  onClaimClick,
  claimSucceeded,
  claimErrorMessage,
  onPromoCodeChange,
  claimSuccessMessage
}) => {

  const { promoStore } = useStore();

  const t = useTranslation();

  useEffect(() => {
    return () => {
      promoStore.resetClaimPromoResponse();
    };
  }, []);

  return (
    <div className="promo-bg">

      <div className={`promo-modal ${claimSucceeded ? 'success' : ''}`}>

        <div className="promo-form">

          <div className="modal-title">{t(T.CLAIM_YOUR_FREE_SPINS)}</div>

          <div className="modal-description">{t(T.ENTER_PROMO_CODE)}</div>

          <div className="input-wr">
            <input
              type="text"
              name="promoCode"
              autoComplete="off"
              onChange={(event) => onPromoCodeChange(event.target.value)}
              className={`promocode-input ${claimErrorMessage ? 'error' : ''}`}
            />
            <p className="error-message">{ claimErrorMessage }</p>
          </div>
          <button
            onClick={onClaimClick} 
            disabled={!promoCode.trim()}
            className={`claim-button ${claimLoading ? 'loading' : ''}`}
          >
            <span className="claim">{t(T.CLAIM)}</span>
            <img src={PromoLoader} alt="loading..." className="loading-spinner" />
          </button>
          <div className="close-button" onClick={onClose}>&#x2715;</div>
          <div className="gift-icons">
            <img className="icon-top" src={PromoGift} alt="gift-icon" />
            <img className="icon-bottom" src={PromoGift} alt="gift-icon" />
          </div>
        </div>

        <div className="success-content">
          <div className="modal-title">{t(T.CONGRATULATIONS)}</div>
          <div className="modal-description">
            { claimSuccessMessage }
          </div>
          <div className="close-button" onClick={onClose}>&#x2715;</div>
          <button className="claim-button" onClick={onClose}>
            <span className="claim">{t(T.OK)}</span>
          </button>
        </div>

      </div>
    </div>
  );
};
